import { render } from "./PartialPaymentModal.vue?vue&type=template&id=bf0873c4"
import script from "./PartialPaymentModal.vue?vue&type=script&lang=js"
export * from "./PartialPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__